import React from 'react';
import moment from 'moment';
import numeral from 'numeral';
import FireIcon from 'components/shared/icon/fire-icon';
import { Button, Link, Text } from 'components/shared/uniform';

class ContentItem extends React.Component {
  static propTypes = {
    inlineFeedViews: React.PropTypes.number.isRequired,
    title: React.PropTypes.string.isRequired,
    thumbnailUrl: React.PropTypes.string,
    dateCreated: React.PropTypes.string.isRequired,
    id: React.PropTypes.string.isRequired,
    tweetText: React.PropTypes.string,
    views: React.PropTypes.number.isRequired,
    reactionCount: React.PropTypes.number.isRequired,
    onShareVideoClick: React.PropTypes.func.isRequired,
  }

  constructor() {
    super();
    this.getDateCreated = this.getDateCreated.bind(this);
    this.getReactionCount = this.getReactionCount.bind(this);
    this.getViews = this.getViews.bind(this);
  }

  getDateCreated() {
    function capitalize(text) {
      return text.charAt(0).toUpperCase() + text.slice(1);
    }

    const dateCreated = capitalize(moment.utc(this.props.dateCreated).fromNow());

    return dateCreated;
  }

  getReactionCount() {
    if (!this.props.reactionCount) return null;
    const reactionCount = numeral(this.props.reactionCount).format();
    return (
      <div className="meta-block uni-text--micro">
        <div className="meta-icon fire-icon"><FireIcon /></div> {reactionCount}
      </div>
    );
  }

  getViews() {
    const views = this.props.views + this.props.inlineFeedViews;
    const num = numeral(views).format();
    const label = views === 1 ? 'View' : 'Views';
    return num + ' ' + label;
  }

  shareVideo = e => {
    e.preventDefault();
    this.props.onShareVideoClick(this.props.id, this.props.title, '/video/' + this.props.id, this.props.tweetText);
    return false;
  }

  render() {
    const thumbnailStyle = this.props.thumbnailUrl ? {
      backgroundImage: 'url(' + this.props.thumbnailUrl + ')',
    } : {};

    return (
      <div className="video-wrapper">
        <div className="video">
          <a href={'/video/' + this.props.id}>
            <div className="thumbnail" style={thumbnailStyle}>
              <div className="thumbnail-gradient">
              </div>
            </div>
          </a>

          <div className="video-info">
            <Text level="large" className="title">
              <Link type="implied" href={'/video/' + this.props.id} className="video-link">
                {this.props.title}
              </Link>
            </Text>

            <div className="meta-columns">
              <div className="meta meta-left">
                {this.getReactionCount()}
              </div>
              <div className="meta meta-right uni-text--micro uni-text--nonessential">
                <span className="meta-text">{this.getDateCreated()}</span>
                <span className="meta-text">{this.getViews()}</span>
              </div>
            </div>
          </div>

          <div className="video-actions">
            <Button
              size="small"
              type="secondary"
              style="minimal"
              collapsePadding="horizontal"
              key="share"
              icon="share"
              onClick={this.shareVideo}>
              Share
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default ContentItem;
